
<mat-card appearance="outlined" [@fadeInOut] *ngIf="selectedDataSourceType">
    <mat-card-header style="background: inherit">
        <mat-card-title style="font-size: 14px; color: #c65f00;margin-top: -20px;margin-left:-20px;">
            <ng-container *ngIf="savedIngestConfig?.dataConnector?.dataConnectorType">
              Cannot change the Data Connector Type for this Ingest Farm. Add a new Ingest Farm to do so.
            </ng-container>
            <ng-container *ngIf="!savedIngestConfig?.dataConnector?.dataConnectorType">
              Select a Data Connector Type
            </ng-container>
          </mat-card-title>
    </mat-card-header>
    <mat-card-content>
       <!-- <div #dataSourceCard style="display: flex; border-spacing: 20px;align-items: center;">
            <span style="width: 300px;" >
            <mat-button-toggle-group [value]="ingestConfigViewModel.dataConnectorType" >
                <ng-container *ngFor="let connector of dataConnectors">
                    <mat-button-toggle [value]="connector.dataConnectorType" (click)="onDataConnectorSelected(connector)">{{ connector.title }}</mat-button-toggle> -->
                  <!--  <mat-button-toggle 
                        [value]="connector.dataConnectorType" 
                        [disabled]="connector.dataConnectorType !== savedIngestConfig?.dataConnector?.dataConnectorType && (savedIngestConfig?.dataConnector?.dataConnectorType != undefined)" 
                        (click)="onDataConnectorSelected(connector)">
                        {{ connector.title }}
                    </mat-button-toggle>
                </ng-container>
            </mat-button-toggle-group>
            </span>
            <span matTooltipClass="custom-mat-tooltip" style="margin-left: 150px;" >
                <mat-slide-toggle color="primary" labelPosition="before" [checked]="true">Excel Turbo Mode</mat-slide-toggle>
              </span>
              <span matTooltipClass="custom-mat-tooltip" style="margin-left: 10px;">
                <mat-slide-toggle color="primary" labelPosition="before" 
                [(ngModel)]="ingestConfigViewModel.isMultiTabIngest" 
                 [checked]="true"
                 (ngModelChange)="onToggleChange($event)"
                 
                 >Multi-tab Ingest</mat-slide-toggle>
              </span>
              <span matTooltipClass="custom-mat-tooltip" style="margin-left: 100px;">
                <mat-slide-toggle color="primary" labelPosition="before" >Ingest All</mat-slide-toggle>
              </span>
              <span>
                <mat-form-field appearance="legacy" style="margin-left: 30px;width: 130px;">
                    <mat-label>Sample Start</mat-label>
                    <input matInput placeholder="5000" type="number">
                </mat-form-field>
            </span>
            <span>
                <mat-form-field appearance="legacy" style="margin-left: 20px;;width: 130px;">
                    <mat-label>Sample End</mat-label>
                    <input matInput placeholder="6000" type="number">
                </mat-form-field>
            </span>
    
        </div>-->



        <div class="main-container" style="margin-left: -16px;margin-top: 5px;">
            <div class="left-pane" #dataSourceCard>
              <mat-button-toggle-group [value]="ingestConfigViewModel.dataConnectorType">
                <ng-container *ngFor="let connector of dataConnectors">
                  <mat-button-toggle
                    [value]="connector.dataConnectorType"
                    [disabled]="connector.dataConnectorType !== savedIngestConfig?.dataConnector?.dataConnectorType && (savedIngestConfig?.dataConnector?.dataConnectorType != undefined)"
                    (click)="onDataConnectorSelected(connector)">
                    {{ connector.title }}
                  </mat-button-toggle>
                </ng-container>
              </mat-button-toggle-group>
            </div>
          
            <div class="center-pane">
              <div *ngIf="ingestConfigViewModel.dataConnectorType == 4">
                <mat-slide-toggle
                  color="primary"
                  labelPosition="before"
                  [(ngModel)]="ingestConfigViewModel.excelTurboMode"
                  [checked]="true" style="margin-right: 7px;">
                  Excel Turbo Mode
                </mat-slide-toggle>
                
                <mat-slide-toggle
                  color="primary"
                  labelPosition="before"
                  [(ngModel)]="ingestConfigViewModel.isMultiTabIngest"
                  [checked]="true"
                  (ngModelChange)="onToggleChange($event)">
                  Multi-tab Ingest
                </mat-slide-toggle>
              </div>
            </div>
          
            <div class="right-pane" >
              <div class="right-pane-content">
                <fieldset class="outer-box">
                  <legend class="box-label">Developer Data Only</legend>
                  <mat-slide-toggle 
                    color="primary"
                    labelPosition="before"
                    [(ngModel)]="ingestConfigViewModel.ingestAll" style="margin-left: -2px;margin-top: -30px;">
                    Ingest All
                  </mat-slide-toggle>
          
                  <mat-form-field  style="width: 100px;margin-top: -15px;">
                    <mat-label>Sample Start</mat-label>
                    <input matInput placeholder="5000" type="number" [min]="1" [(ngModel)]="ingestConfigViewModel.sampleStart" appIntegerPositiveOnly>
                  </mat-form-field>
          
                  <mat-form-field  style="width: 100px;margin-top: -15px;">
                    <mat-label>Sample End</mat-label>
                    <input matInput placeholder="6000" type="number" [min]="10" [(ngModel)]="ingestConfigViewModel.sampleEnd" appIntegerPositiveOnly>
                  </mat-form-field>
                </fieldset>
              </div>
            </div>
        </div>
          
    </mat-card-content>
</mat-card>

<mat-card appearance="outlined" [@fadeInOut] *ngIf="ingestConfigViewModel.dataConnectorType">
    <!-- <mat-card-header style="background: inherit">
        <mat-card-title style="font-size: 14px; color: #d36b0b;">Configure the Connector</mat-card-title>
    </mat-card-header> -->
    <mat-card-content [ngSwitch]="ingestConfigViewModel.dataConnectorType">
        <app-rest-api-data-connector *ngSwitchCase="dataConnectorType.RestApi"
            [dataTransformConfigViewModel]="viewModel" [ingestConfigViewModel]="ingestConfigViewModel"></app-rest-api-data-connector>
        <app-file-data-connector *ngSwitchCase="dataConnectorType.Text" [dataTransformConfigViewModel]="viewModel"
            [dataSourceType]="viewModel.dataSourceType" [ingestConfigViewModel]="ingestConfigViewModel">
        </app-file-data-connector>
        <app-excel-data-connector *ngSwitchCase="dataConnectorType.Excel" [dataTransformConfigViewModel]="viewModel"
            [dataSourceType]="viewModel.dataSourceType" [ingestConfigViewModel]="ingestConfigViewModel">
        </app-excel-data-connector>
        <!-- <app-sql-data-connector *ngSwitchCase="dataConnectorType.Database" [dataTransformConfigViewModel]="viewModel" [ingestConfigViewModel]="ingestConfigViewModel">
        </app-sql-data-connector> -->
        <ng-container *ngSwitchCase="dataConnectorType.Database">
          <mat-button-toggle-group [value]="ingestConfigViewModel.databaseType">
            <ng-container *ngFor="let connector of dataBaseConnectors">
              <mat-button-toggle
                [value]="connector.databaseType"
                [disabled]="connector.databaseType !== savedIngestConfig?.dataConnector?.databaseType && (savedIngestConfig?.dataConnector?.databaseType != undefined)"
                (click)="onDataBaseConnectorSelected(connector)">
                {{ connector.title }}
              </mat-button-toggle>
            </ng-container>
          </mat-button-toggle-group>
          <!-- <mat-button-toggle-group [(ngModel)]="ingestConfigViewModel.databaseType" name="dbType" aria-label="Database Type" (click)="onDataBaseSelected()">
            <mat-button-toggle [value]="databaseType.SQL">SQL Server</mat-button-toggle>
            <mat-button-toggle [value]="databaseType.Oracle">Oracle DB</mat-button-toggle>
            <mat-button-toggle [value]="databaseType.MySql">My SQL</mat-button-toggle>
            <mat-button-toggle [value]="databaseType.Vertica">Vertica</mat-button-toggle>
            <mat-button-toggle [value]="databaseType.Other">Other</mat-button-toggle>
          </mat-button-toggle-group> -->
        </ng-container>
        <app-feather *ngSwitchCase="dataConnectorType.Feather" [dataTransformConfigViewModel]="viewModel"
        [dataSourceType]="viewModel.dataSourceType" [ingestConfigViewModel]="ingestConfigViewModel">
    </app-feather>
     <app-parquet-data-connector *ngSwitchCase="dataConnectorType.Parquet" [dataTransformConfigViewModel]="viewModel"
        [dataSourceType]="viewModel.dataSourceType" [ingestConfigViewModel]="ingestConfigViewModel">
    </app-parquet-data-connector>
    </mat-card-content>
</mat-card>
<mat-card appearance="outlined" [@fadeInOut] *ngIf="ingestConfigViewModel.dataConnectorType==dataConnectorType.Database && ingestConfigViewModel.databaseType">
  <mat-card-content [ngSwitch]="ingestConfigViewModel.databaseType">
      <app-sql-data-connector *ngSwitchCase="databaseType.SQL" [dataTransformConfigViewModel]="viewModel" [ingestConfigViewModel]="ingestConfigViewModel">
      </app-sql-data-connector>
      <app-oracle-data-connector *ngSwitchCase="databaseType.Oracle" [dataTransformConfigViewModel]="viewModel" [ingestConfigViewModel]="ingestConfigViewModel">
      </app-oracle-data-connector>
      <app-mysql-data-connector *ngSwitchCase="databaseType.MySql" [dataTransformConfigViewModel]="viewModel" [ingestConfigViewModel]="ingestConfigViewModel">
      </app-mysql-data-connector>
      <app-vertica-data-connector *ngSwitchCase="databaseType.Vertica" [dataTransformConfigViewModel]="viewModel" [ingestConfigViewModel]="ingestConfigViewModel">
      </app-vertica-data-connector>
      <app-other-data-connector *ngSwitchCase="databaseType.Other" [dataTransformConfigViewModel]="viewModel" [ingestConfigViewModel]="ingestConfigViewModel">
      </app-other-data-connector>
  </mat-card-content>
</mat-card>